// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const FitImage = styled.img`
  max-width: 100%;
  max-height: 18rem;
  object-fit: contain;
  margin: 1rem auto;
`;
